'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrimaryMouseButton;
var PRIMARY_MOUSE_BUTTON = 0;
function isPrimaryMouseButton(event) {
  return event.type === 'mousedown' && event.button === PRIMARY_MOUSE_BUTTON;
}